var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simpleNotifyPage',{attrs:{"action":_vm.action,"hasBar":false},scopedSlots:_vm._u([{key:"subtitle",fn:function(){return [_vm._v(" 你的商家尚未與"+_vm._s(_vm.layoutProviderName)+"合作，需請你商家的主要管理員申請 ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }